import BindingContext from "@odata/BindingContext";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import { InvalidateDeclarationFormViewCustomData } from "@pages/payroll/taxpayerDeclaration/taxpayerDeclarationMassCreateDialog/InvalidateDeclarationFormView";
import i18next from "i18next";

import { FieldType } from "../../../enums";
import { getUtcDate } from "../../../types/Date";
import { IFormDef } from "../../../views/formView/Form";
import FormView from "../../../views/formView/FormView";

export const TempDateValidToPath = BindingContext.localContext("TempDateValidToPath");

export const getDefinitions: IGetDefinition = (): IDefinition => {
    const form: IFormDef = {
        id: `InvalidateDeclarationSpecialForm`,
        summary: [],
        translationFiles: getDefinitions.translationFiles,
        formControl: FormView,
        fieldDefinition: {
            [TempDateValidToPath]: {
                type: FieldType.MonthYear,
                label: i18next.t("TaxpayerDeclaration:Form.AppliedTo"),
                defaultValue: getUtcDate(),
                fieldSettings: {
                    minDate: (args) => {
                        const storage = args.storage;
                        return (storage.getCustomData() as InvalidateDeclarationFormViewCustomData).minDateForInvalidateDeclaration;
                    }
                },
                isRequired: true,
                useForValidation: true,
                customizationData: {
                    useForCustomization: false
                }
            },
        },
        groups: [{
            id: "main",
            rows: [[{ id: TempDateValidToPath }]]
        }]
    };


    return {
        form
    };
};

getDefinitions.translationFiles = ["TaxpayerDeclaration", "Common"];
